import { SortDirection } from './sortDirection';

export class SearchParameter {
    public sortDirection: SortDirection = SortDirection.Ascending;
    public columnSorting: string;
    public currentPageIndex: number = 0;
    public pageSize: number = 10;
}